import { Component, Inject, Injector, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Store } from '@ngxs/store';
import { firstValueFrom, Subscription } from 'rxjs';
import { BaseComponent } from 'src/app/common/base/base.component';
import { ChecklistBuilderAnnotationsService } from 'src/app/components/checklists/checklist-builder/checklist-builder-annotations/checklist-builder-annotations.service';
import { ChecklistBuilderService } from 'src/app/components/checklists/checklist-builder/checklist-builder.service';
import { Annotation, Checklist } from 'src/app/components/checklists/checklists';
import { ImageUploadService } from 'src/app/services/file/image-upload.service';
import { User } from 'src/app/components/catalogs/user-catalog/services/user';
import { WfSignature, WfTaskLocalResource } from 'src/app/components/workflow/workflow';
import { AppStateService } from 'src/app/store/app-state-service';

@Component({
  selector: 'app-checklist-tasks-annotations-edit',
  templateUrl: './checklist-tasks-annotations-edit.component.html',
  styleUrls: ['./checklist-tasks-annotations-edit.component.scss']
})
export class ChecklistTasksAnnotationsEditComponent extends BaseComponent implements OnInit {

  s: WfSignature;
  task: WfTaskLocalResource;
  annotation: Annotation;
  annotationText?: string | null;
  isResponse: boolean;
  isComment: boolean;
  currentChecklist: Checklist;

  quillConfig = {
    toolbar: {
      container: [
        ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ color: [] }, { background: [] }],
        [{ script: 'sub' }, { script: 'super' }],      // superscript/subscript
        [{ align: [] }],
        ['link', 'image'],
        ['clean']

      ]
    },
    // autoLink: true,
    keyboard: {
      bindings: {
        enter: {
          key: 13,
          handler: () => {
            return true;
          }
        }
      }
    },
    imageDrop: true,
    imageResize: true
  };

  wfTaskLocal!: WfTaskLocalResource;

  constructor(
    protected override injector: Injector,
    private dialogRef: MatDialogRef<ChecklistTasksAnnotationsEditComponent>,
    private annotationsService: ChecklistBuilderAnnotationsService,
    private _image: ImageUploadService,
    private builderService: ChecklistBuilderService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    super(injector);
    this.s = data.s;
    this.isResponse = data.isResponse;
    this.isComment = data.isComment;
    this.annotation = data.annotation;
    this.annotationText = this.isResponse ? this.annotation?.responseText : this.annotation?.annotationText;
    this.task = data.task;
    this.currentChecklist = data.currentChecklist;
  }

  ngOnInit() {
    if (this.s.id)
      this.builderService.getWFTaskLocal(this.s.id).toPromise().then(data => {
        if (data)
          this.wfTaskLocal = data;
      });
  }

  async accept() {
    try {
      let data: WfTaskLocalResource | undefined;
      if (!this.isResponse) {
        if (this.annotation == null) {
          this.annotation = {
            id: 0,
            annotationText: this.annotationText,
            wfTaskLocalID: this.task.id,
            checklistID: this.currentChecklist.id,
            status: 0
          };
          data = await firstValueFrom(this.annotationsService.create(this.annotation));
        }
        else {
          this.annotation.annotationText = await this.resolveText(this.annotationText, 'Suggestion');
          data = await firstValueFrom(this.annotationsService.update(this.annotation));
        }
      }
      else {
        this.annotation.responseText = await this.resolveText(this.annotationText, 'Response');
        this.annotation.responseBy = this.getCurrentUser()?.id;
        this.annotation.responseByName = this.getCurrentUser()?.name;
        this.annotation.responseDate = new Date();
        data = await firstValueFrom(this.annotationsService.update(this.annotation));
      }
      this.dialogRef.close(data);
    }
    catch (e) {
      console.error(e);
      this.alert.defaultError();
    }
  }

  // Uploads any inline base64 images and returns the final text. Falls back to the raw
  // text when the checklist or task context needed to build the upload path is missing.
  private async resolveText(text: string | null | undefined, folder: string): Promise<string | null | undefined> {
    const code = this.currentChecklist.documentType?.code?.trim();
    const wfSectionLocalID = this.wfTaskLocal?.wfStepLocal?.wfSectionLocalID;
    if (text && code && wfSectionLocalID != null)
      return await this.uploadImages(text, code + '/' + this.currentChecklist.serialNo + '/WFSectionLocal-' + wfSectionLocalID + '/WFTaskLocal-' + this.s.id + '/' + folder + '-' + this.annotation.id + '/');
    return text;
  }

  cancel() {
    this.dialogRef.close();
  }

  async uploadImages(textValue: string, path: string) {
    const text = await this._image.uploadImagesToServer(textValue, path);
    return text;
  }

}
